<template>
  <div class="product-tab py-4" :class="{ 'px-8': !breakpointXs, 'px-2': breakpointXs }">
    <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
      <v-row>
        <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
          <TextField
            v-model="serialNo"
            disabled
            :loading="isAddProductFormLoading || savingExportJob"
            label="Serial No"
            showIcons
            :showOnlyErrorIcons="true"
          />
        </v-col>
        <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
          <AutoComplete
            v-model="ritcCodeDropdownValue"
            :items="ritcCodesArray"
            item-text="text"
            :search-input.sync="search"
            required
            :return-object="true"
            :loading="isAddProductFormLoading || savingExportJob"
            label="RITC Code"
            rules="required"
            showIcons
            :showOnlyErrorIcons="true"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
          <v-textarea
            v-model="description"
            filled
            rows="4"
            required
            :loading="isAddProductFormLoading || savingExportJob"
            label="Product Description"
            showIcons
            :showOnlyErrorIcons="true"
          ></v-textarea>
        </v-col>
        <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
          <TextField
            v-model="quantity"
            rules="required"
            type="number"
            min="0"
            showIcons
            :showOnlyErrorIcons="true"
            :loading="isAddProductFormLoading || savingExportJob"
            label="Item Quantity"
          />
          <v-row>
            <v-col cols="12" :xs="12" :sm="12" :md="12" :lg="12">
              <AutoComplete
                v-model="unitOfMeasurementDropdownValue"
                :return-object="true"
                item-text="text"
                :items="units"
                rules="required"
                :loading="isAddProductFormLoading || savingExportJob"
                label="Quantity Unit (As per RITC)"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :xs="12" :sm="3" :md="3" :lg="3">
          <TextField
            v-model="amount"
            showIcons
            :showOnlyErrorIcons="true"
            :loading="isAddProductFormLoading || savingExportJob"
            label="Amount"
          />
        </v-col>
        <v-col cols="12" :xs="12" :sm="3" :md="3" :lg="3">
          <TextField
            v-model="noOfUnit"
            rules="required|max:8"
            showIcons
            :showOnlyErrorIcons="true"
            :loading="isAddProductFormLoading || savingExportJob"
            label="Per"
          />
        </v-col>
        <v-col cols="12" :xs="12" :sm="3" :md="3" :lg="3">
          <TextField
            v-model="unitPrice"
            rules="required"
            type="number"
            showIcons
            readonly
            :showOnlyErrorIcons="true"
            :loading="isAddProductFormLoading || savingExportJob"
            label="Unit Price per item"
          />
        </v-col>
        <v-col cols="12" :xs="12" :sm="3" :md="3" :lg="3">
          <AutoComplete
            v-model="unitOfRateDropdownValue"
            :return-object="true"
            item-text="text"
            :items="units"
            rules="required"
            :loading="isAddProductFormLoading || savingExportJob"
            label="Price Unit"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
          <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
            <v-btn
              width="140"
              color="info"
              large
              class="white--text"
              :loading="isAddProductFormLoading || savingExportJob"
              @click="$emit('close-dialog', true)"
            >
              <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
              <span class="font-weight-bold fs-15">Previous</span>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
          <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
            <v-btn
              width="140"
              color="button-primary"
              large
              class="white--text"
              :loading="isAddProductFormLoading || savingExportJob"
              @click="passes(saveProduct)"
            >
              <span class="font-weight-bold fs-15">Save</span>
            </v-btn>
            <div class="ml-2 mr-2 my-1"></div>
            <v-btn
              width="140"
              color="info"
              large
              class="white--text"
              :loading="isAddProductFormLoading || savingExportJob"
              @click="$emit('change-tab', 1)"
            >
              <span class="font-weight-bold fs-15">Next</span>
              <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import AutoComplete from "@/components/AutoComplete";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "ProductsTab",
  components: {
    TextField,
    ValidationObserver,
    AutoComplete
  },
  mounted() {
    this.serialNo = this.itemSrNo;
    this.description = this.prodDesc;
    if (this.ritcCodeDropdownValue !== null && this.ritcCodeDropdownValue !== "") {
      this.ritcCodesArray = [
        {
          code: this.ritcCode,
          text: this.ritcCodeDropdownValue
        }
      ];
    }
    this.checkScheme();
    this.checkUnitOfRate();
  },
  data() {
    return {
      // Product Tab
      isAddProductFormLoading: false,
      dialog: false,
      description: "",
      per: 1,
      search: null,
      ritcCodesArray: []
    };
  },
  props: {
    itemSrNo: {
      type: Number,
      default: 1
    },
    invoiceSrNo: {
      type: Number,
      default: 1
    },
    isNewItem: {
      type: Boolean,
      default: true
    }
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    checkUnitOfRate() {
      const unitOfRateDropdown = this.$store.state.ExportModuleStore.item.unitOfRateDropdownValue;
      const unitOfRate = this.$store.state.ExportModuleStore.item.unitOfRate;
      if (unitOfRateDropdown !== null && unitOfRate !== null) {
        this.unitOfRateDropdownValue = {
          text: unitOfRateDropdown,
          textIdentifier: unitOfRate
        };
      } else {
        this.unitOfRateDropdownValue = {
          text: this.$store.state.ExportModuleStore.item.unitOfMeasurementDropdownValue,
          textIdentifier: this.$store.state.ExportModuleStore.item.unitOfMeasurement
        };
      }
      return;
    },
    checkScheme() {
      const item = this.$store.getters.item;
      if (item.schemeCode !== undefined && item.schemeCode !== null) {
        const schemeCodeObject = this.$store.getters.eximSchemeCodes.find(
          eximScheme => eximScheme.code === item.schemeCode
        );
        if (schemeCodeObject !== undefined && schemeCodeObject !== null) {
          this.$emit("selected-exim-scheme", schemeCodeObject);
        }
      }
    },
    saveProduct() {
      this.prodDesc = this.description;
      const item = this.$store.getters.item;
      item.itemSrNo = this.itemSrNo;
      item.invoiceSrNo = this.invoiceSrNo;
      if (this.description.length === 0 || this.description.length >= 121) {
        const errorMessage = "Product description is required and must be less than 120 characters";
        this.throwErrorMessage(errorMessage);
        return;
      }
      this.$store.commit(MT.SET_ITEMS_IN_EXPORT_JOB, { ...item });
      this.saveExportJob();
      this.$emit("item-saved");
      return;
    },
    makeFieldsNull() {
      this.serialNo = null;
      this.ritcCode = null;
      this.descriptionOfGoods1 = null;
      this.quantity = null;
      this.unit = null;
      this.unitPrice = null;
      this.unitOfRate = null;
    },
    computeRitcCodes(searchedString) {
      this.ritcCodesArray = this.ritcCodes.filter(ritcCode => {
        return searchedString
          .toLowerCase()
          .split(" ")
          .every(v => ritcCode.text.toLowerCase().includes(v));
      });
    }
  },
  beforeDestroy() {
    this.checkUnitOfRate();
  },
  watch: {
    search(value) {
      if (value !== null && value.length > 3) {
        this.computeRitcCodes(value);
      }
    }
  },
  computed: {
    currencies() {
      return this.$store.getters.currencies;
    },
    tableHeaders() {
      return [
        { text: "Sr No", value: "srNo" },
        { text: "Product Description", value: "productDescription" },
        { text: "RITC Code", value: "ritcCode" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit", value: "unit" },
        { text: "Unit Price", value: "unitPrice" },
        { text: "Per", value: "per" },
        { text: "Unit", value: "perUnit" },
        { text: "Amount", value: "amount" },
        { text: "Action", value: "acton" }
      ];
    },
    units() {
      return this.$store.getters.units;
    },
    ritcCodes() {
      return this.$store.getters.ritcCodes;
    },
    serialNo: {
      get() {
        return this.itemSrNo;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_ITEM_SR_NO, { value });
      }
    },
    unitOfMeasurement: {
      get() {
        return this.$store.state.ExportModuleStore.item.unitOfMeasurement;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_UNIT_OF_MEASUREMENT, { value });
      }
    },
    unitOfMeasurementDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.item.unitOfMeasurementDropdownValue;
      },
      set(unitOfMeasurementObject) {
        this.$store.commit(MT.SET_ITEM_UNIT_OF_MEASUREMENT_DROPDOWN_VALUE, { value: unitOfMeasurementObject.text });
        this.unitOfMeasurement = unitOfMeasurementObject.textIdentifier;
        this.unitOfRateDropdownValue = unitOfMeasurementObject;
        return;
      }
    },
    unitOfRate: {
      get() {
        const unitOfRate = this.$store.state.ExportModuleStore.item.unitOfRate;
        if (unitOfRate !== null && unitOfRate !== undefined) {
          return unitOfRate;
        }
        return this.$store.state.ExportModuleStore.item.unitOfMeasurement;
      },
      set(unitOfRateObject) {
        this.$store.commit(MT.SET_ITEM_UNIT_OF_RATE, { value: unitOfRateObject.textIdentifier });
      }
    },
    unitOfRateDropdownValue: {
      get() {
        const unitOfRateDropdown = this.$store.state.ExportModuleStore.item.unitOfMeasurementDropdownValue;
        if (unitOfRateDropdown !== null) {
          return unitOfRateDropdown;
        }
        return this.$store.state.ExportModuleStore.invoice.invoiceCurrencyCodeDropdownValue;
      },
      set(unitOfRateObject) {
        this.$store.commit(MT.SET_ITEM_UNIT_OF_RATE_DROPDOWN_VALUE, { value: unitOfRateObject.text });
        this.unitOfRate = unitOfRateObject;
        return;
      }
    },
    ritcCode: {
      get() {
        return this.$store.state.ExportModuleStore.item.ritcCode;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_RITC_CODE, { value });
      }
    },
    ritcCodeDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.item.ritcCodeDropdownValue;
      },
      set(ritcCodeObject) {
        this.$store.commit(MT.SET_ITEM_RITC_CODE_DROPDOWN_VALUE, { value: ritcCodeObject.text });
        this.ritcCode = ritcCodeObject.code;
        this.unitOfMeasurementDropdownValue = this.units.find(
          unit => unit.textIdentifier === ritcCodeObject.textIdentifier
        );
        return;
      }
    },
    prodDesc: {
      get() {
        const description1 = this.$store.state.ExportModuleStore.item.descriptionOfGoods1;
        const description2 = this.$store.state.ExportModuleStore.item.descriptionOfGoods2;
        const description3 = this.$store.state.ExportModuleStore.item.descriptionOfGoods3;
        return [description1, description2, description3].join("");
      },
      set(description) {
        if (description.length < 40) {
          this.$store.commit(MT.SET_ITEM_DESCRIPTION_OF_GOODS1, {
            value: description.substring(0, description.length)
          });
          this.$store.commit(MT.SET_ITEM_DESCRIPTION_OF_GOODS2, {
            value: null
          });
          this.$store.commit(MT.SET_ITEM_DESCRIPTION_OF_GOODS3, {
            value: null
          });
        } else if (description.length >= 40 && description.length < 80) {
          this.$store.commit(MT.SET_ITEM_DESCRIPTION_OF_GOODS1, { value: description.substring(0, 40) });
          this.$store.commit(MT.SET_ITEM_DESCRIPTION_OF_GOODS2, {
            value: description.substring(40, description.length)
          });
          this.$store.commit(MT.SET_ITEM_DESCRIPTION_OF_GOODS3, {
            value: null
          });
        } else if (description.length >= 80 && description.length < 120) {
          this.$store.commit(MT.SET_ITEM_DESCRIPTION_OF_GOODS1, { value: description.substring(0, 40) });
          this.$store.commit(MT.SET_ITEM_DESCRIPTION_OF_GOODS2, { value: description.substring(40, 80) });
          this.$store.commit(MT.SET_ITEM_DESCRIPTION_OF_GOODS3, {
            value: description.substring(80, description.length)
          });
        }
        return;
      }
    },
    quantity: {
      get() {
        return this.$store.state.ExportModuleStore.item.quantity;
      },
      set(value) {
        this.unitPrice = (parseFloat(this.amount) / parseFloat(this.quantity)).toFixed(4);
        this.$store.commit(MT.SET_ITEM_QUANTITY, { value });
        //this.$store.commit(MT.SET_ITEM_UNIT_PRICE, { price });
      }
    },
    unitPrice: {
      get() {
        const itemUnitPrice = this.$store.state.ExportModuleStore.item.unitPrice;
        if (itemUnitPrice !== null) {
          return itemUnitPrice;
        }
        return this.$store.state.ExportModuleStore.invoice.invoiceValue;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_UNIT_PRICE, { value });
      }
    },
    amount: {
      get() {
        const itemValue = this.$store.state.ExportModuleStore.item.itemValue;
        if (itemValue !== undefined && itemValue !== null) {
          return itemValue;
        }
        return parseFloat(this.$store.state.ExportModuleStore.invoice.invoiceValue);
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_ITEM_VALUE, { value });
        const unitPrice = (parseFloat(value) / parseFloat(this.$store.state.ExportModuleStore.item.quantity)).toFixed(
          4
        );
        this.unitPrice = unitPrice;
      }
    },

    noOfUnit: {
      get() {
        const noOfUnit = this.$store.state.ExportModuleStore.item.noOfUnit;
        if (noOfUnit === null) {
          return this.per;
        }
        return this.$store.state.ExportModuleStore.item.noOfUnit;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_NO_OF_UNIT, { value });
      }
    }
  }
};
</script>
<style lang="scss">
.product-tab {
  min-height: 350px;
  &__table {
    .v-data-table {
      background: transparent !important;
    }
  }
}

.mw-25 {
  max-width: 25rem;
}
</style>
